import { dataShareDBGet, dataShareDBSet } from '@weblite/action/shareDB'
import {
  WAPP_COMMUNICATE_SHAREDB_GET,
  wappCommunicateShareDBGet,
  WAPP_COMMUNICATE_SHAREDB_SET,
} from '@weblite/wapp-communication-action/shareDB'
import { sendOldActionToWapp } from '$logic/wapp-communication/wapp-communication.publish'
import { wappSub } from '$helper/functions/subscription'
import { send, wsReq } from '$setup/ws'

wappSub.subscribe(
  WAPP_COMMUNICATE_SHAREDB_GET,
  async ({ payload: { path }, meta, meta: { mode, wisId } }) => {
    if (mode === 'customize') return
    const {
      payload: { shareDB },
    } = await wsReq(dataShareDBGet({ wisId, path }))
    sendOldActionToWapp(wappCommunicateShareDBGet({ path, shareDB }), meta)
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_SHAREDB_SET,
  ({
    payload: { path, qlite, defaultVal, options },
    meta: { wisId, mode },
  }) => {
    if (mode !== 'customize')
      send(
        dataShareDBSet({ path, qlite, defaultVal, options, wisId }),
        true,
        -1,
      )
  },
  true,
)
